import { Box, Button, ButtonGroup, Card, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAvailableStudents } from '../../student/studentSlice';
import ContentSelector from '../../subcomponents/ContentSelector';
import { showAlert } from '../../subcomponents/alertSlice';
import { fetchPerformancesForMove, fetchSubscriptions, fetchUnsubscriptions, postSubscriptionsMove, resetSubscriptionStatus } from './subscriptionSlice';
import ContentLoader from '../../subcomponents/ContentLoader';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    width: '90%',
    maxHeight: '90%',
    boxShadow: 24,
};

export default function SubscriptionsMoveCard({ performanceId, handleClose, activityId, studentIds }) {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.user);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { movePerformances, moveSubscriptions } = useSelector((state) => state.subscription);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { appSettings } = useSelector((state) => state.settings.app);
    const { activeDepartment } = useSelector((state) => state.settings.theme);

    const [newPerformanceId, setNewPerformanceId] = useState([]);
    const [newIsReservation, setNewIsReservation] = useState(false);
    const [showAllActivities, setShowAllActivities] = useState(false);

    useEffect(() => {
        const departmentId = siomSettings.useMultipleDepartments && activeDepartment ? activeDepartment[0]?.id : "00000000-0000-0000-0000-000000000000";

        dispatch(fetchPerformancesForMove({ currentPerformanceId: performanceId, departmentId: departmentId, activityId: showAllActivities ? null : activityId }));
    }, [showAllActivities]);

    // Post status callback
    useEffect(() => {
        if (moveSubscriptions.status === "success") {
            dispatch(showAlert({ status: true, message: resourceFinal[appLanguage].messages.MOVE_SUCCESS, severity: "success" }))
            dispatch(resetSubscriptionStatus())
            dispatch(fetchSubscriptions(performanceId));
            dispatch(fetchUnsubscriptions(performanceId));
            dispatch(fetchAvailableStudents(performanceId));
            handleClose()
        } else if (moveSubscriptions.status === "failed") {
            dispatch(showAlert({ status: true, message: resourceFinal[appLanguage].messages.MOVE_FAILED, severity: "error" }))
            dispatch(resetSubscriptionStatus({ keys: ['moveSubscriptions'] }));
        }
    }, [dispatch, moveSubscriptions.status]);

    const handleSaveClick = () => {
        var newSubscriptionsToMove = {
            currentPerformanceId: performanceId,
            newPerformanceId: newPerformanceId[0].performanceId,
            studentIds: studentIds,
            isReservation: newIsReservation,
            createdBy: `AP/${user.number}`
        };

        dispatch(postSubscriptionsMove(newSubscriptionsToMove));
    };

    return (
        <Box sx={{ ...modalStyle }}>
            <Card sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', p: 2 }}>
                <Scrollbars autoHeight autoHeightMin="100%" autoHeightMax="100%" autoHideTimeout={1000} autoHideDuration={200}>
                    <Stack spacing={0.5} alignItems="center" sx={{ width: 1 }}>
                        <ContentLoader
                            successCondition={movePerformances.status === "success"}
                            errorCondition={movePerformances.status === "failed"}
                            content={
                                <ContentSelector
                                    content={movePerformances.data}
                                    contentId="performanceId"
                                    contentTitle={resourceFinal[appLanguage].words.PERFORMANCES}
                                    contentHeaders={[
                                        resourceFinal[appLanguage].words.NUMBER,
                                        (appSettings?.appVersion === 2 || siomSettings?.enablePerformanceName) ? resourceFinal[appLanguage].words.PERFORMANCE : "",
                                        resourceFinal[appLanguage].words.ACTIVITY,
                                        resourceFinal[appLanguage].words.SUBSCRIPTIONS,
                                        resourceFinal[appLanguage].words.CAPACITY,
                                        resourceFinal[appLanguage].words.MOMENTS,
                                        resourceFinal[appLanguage].words.START,
                                    ]}
                                    contentRows={[
                                        "performanceNumber",
                                        (appSettings?.appVersion === 2 || siomSettings?.enablePerformanceName) ? "performanceName" : "",
                                        "activityName",
                                        "capacityCurrent",
                                        "capacityLimit",
                                        "performanceMoments",
                                        "momentStart",
                                    ]}
                                    selectedContent={newPerformanceId}
                                    setSelectedContent={setNewPerformanceId}
                                />
                            } />
                        <Typography variant="body1">{resourceFinal[appLanguage].words.STUDENTS}: {studentIds.length}</Typography>
                        <FormControlLabel
                            sx={{ display: 'flex', justifyContent: 'center' }}
                            label={resourceFinal[appLanguage].messages.MOVE_SHOW_ALL_ACTIVITIES}
                            control={
                                <Checkbox checked={showAllActivities} onChange={() => setShowAllActivities(!showAllActivities)} />
                            }
                        />
                        <FormControlLabel
                            sx={{ display: 'flex', justifyContent: 'center' }}
                            label={resourceFinal[appLanguage].messages.SET_RESERVATION}
                            control={
                                <Checkbox onChange={() => setNewIsReservation(!newIsReservation)} />
                            }
                        />
                        <ButtonGroup sx={{ justifyContent: 'center' }}>
                            <Button variant="outlined" color="error" onClick={() => handleClose()}>{resourceFinal[appLanguage].words.CANCEL}</Button>
                            <Button variant="outlined" color="primary" disabled={newPerformanceId.length === 0} onClick={handleSaveClick}>{resourceFinal[appLanguage].words.MOVE}</Button>
                        </ButtonGroup>
                    </Stack>
                </Scrollbars>
            </Card>
        </Box>
    );
}

